import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewsComponent } from './views.component';
import { ViewRoutingModule } from './views.routing';
import { SharedModule } from '../shared/shared.module';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireAuthGuardModule } from '@angular/fire/auth-guard';
import { AgmCoreModule } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { DecimalFormatPipeNP } from './nuevo-proyecto/shared/decimal-pipe.pipe';
import { NumberPipeNP } from './nuevo-proyecto/shared/number-pipe.pipe';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NuevoProyectoComponent } from './nuevo-proyecto/nuevo-proyecto.component';


@NgModule({

  declarations: [ViewsComponent, NuevoProyectoComponent, DecimalFormatPipeNP, NumberPipeNP],
  imports: [
    CommonModule,
    ViewRoutingModule,
    SharedModule,
    NgSelectModule,
    NgxIntlTelInputModule,

    AngularFireAuthModule,
    ReactiveFormsModule,
    AngularFireAuthGuardModule,
    BsDatepickerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA1xsi_iEIGTxr0gk2hJu542G8_E0FAB0Y',
      libraries: ['places'],
    }),
  ],

})
export class ViewsModule { }

